import { Box, Button, Container, Icon } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Profile from '@/js/site/components/dashboards/Profile';
import LoginBox from '@/js/shared/components/loginbox';
import { Loader } from '@/components/loader';
import { SitePage } from '@/pages/site/site-page';
import { ConferencePagesContext } from '@/store';
import { AuthContext } from '@/store';
import { siteStaticRoutes, siteFallbackRoute } from './SiteRoutes.config';
import {
  wrapWithProviders,
  resolveRouteProps,
} from '@/routes/config/route-config.types';
import { SITE } from '@/routes/config/paths';

const SiteRoutes = () => {
  const { authState } = useContext(AuthContext);

  return authState.stateLoaded ? (
    <Router>
      <React.Suspense fallback={<Loader />}>
        <ConferencePagesContext.Consumer>
          {({ getPagesArray }) => (
            <Routes>
              {siteStaticRoutes.map(
                ({ path, Component, providers, props: routeProps }) => (
                  <Route
                    key={path}
                    path={path}
                    element={wrapWithProviders(
                      providers,
                      React.createElement(
                        Component,
                        resolveRouteProps(routeProps)
                      )
                    )}
                  />
                )
              )}
              <Route
                path={`${SITE.PROFILE_ID}`}
                element={!authState.userLoggedIn ? <LoginBox /> : <Profile />}
              />
              {getPagesArray().map(({ id, slug, locked }) => (
                <Route
                  key={`${slug}-${id}`}
                  path={slug}
                  element={
                    locked && !authState.userLoggedIn ? (
                      <Box>
                        <Container maxWidth="xs">
                          <Box>
                            <Button startIcon={<Icon>home</Icon>} href="/">
                              Home
                            </Button>
                          </Box>
                          <LoginBox />
                        </Container>
                      </Box>
                    ) : (
                      <SitePage authState={authState} rootPath={slug} />
                    )
                  }
                />
              ))}
              <Route
                path={siteFallbackRoute.path}
                element={wrapWithProviders(
                  siteFallbackRoute.providers,
                  React.createElement(
                    siteFallbackRoute.Component,
                    resolveRouteProps(siteFallbackRoute.props)
                  )
                )}
              />
            </Routes>
          )}
        </ConferencePagesContext.Consumer>
      </React.Suspense>
    </Router>
  ) : (
    <Box align="center">
      <CircularProgress disableShrink />
    </Box>
  );
};

export default SiteRoutes;
